import { Box } from '@mui/material';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { useUserAppContext } from '../contexts/UserAppContext';
import BottomBar from '../features/bed-management/components/BottomBar';
import CleaningLayout from '../features/environmental-cleaning/components/CleaningLayout';
import TopBar from '../features/bed-management/components/TopBar';
import PatientTransportLayout from '../features/patient-transport/components/PatientTransportLayout';

export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ context }) => {
    if (!context.authenticationContext.isAuthenticated) {
      if (context.healthCenterContext.healthCenterConfig?.id) {
        throw redirect({ to: '/porter-login' });
      } else {
        if (context.authenticationContext.user?.role === 'PORTER') {
          throw redirect({ to: '/health-center-link' });
        }
      }
      if (!context.userAppContext.app) {
        throw redirect({ to: '/app-select' });
      }
      throw redirect({
        to: '/login',
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { app } = useUserAppContext();

  if (app === 'bed-manager') {
    return (
      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <TopBar />
        <Box sx={{ flex: 1, overflow: 'auto' }} paddingX={2}>
          <Outlet />
        </Box>
        <BottomBar />
      </Box>
    );
  } else if (app === 'porter') {
    return <PatientTransportLayout />;
  } else if (app === 'cleaning-agent') {
    return <CleaningLayout />;
  }

  return <Outlet />;
}
